import { render, staticRenderFns } from "./plan-item-4.vue?vue&type=template&id=1bbf05a8&scoped=true&"
import script from "./plan-item-4.vue?vue&type=script&lang=js&"
export * from "./plan-item-4.vue?vue&type=script&lang=js&"
import style0 from "./plan-item-4.vue?vue&type=style&index=0&id=1bbf05a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbf05a8",
  null
  
)

export default component.exports